import { render, staticRenderFns } from "./PayWidget.vue?vue&type=template&id=ba00d726&"
import script from "./PayWidget.vue?vue&type=script&lang=js&"
export * from "./PayWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports